import { UniversalToggle } from '@practium/ui';
import styles from './PolicyToggle.module.css';

interface PolicyToggleProps {
	checked: boolean;
	disabled?: boolean;
	onChange?: (checked: boolean) => void;
}

export const PolicyToggle = ({ checked, disabled = false, onChange }: PolicyToggleProps) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (onChange) {
			onChange(e.target.checked);
		}
	};

	return (
		<div className={styles.toggleGroup}>
			<UniversalToggle checked={checked} disabled={disabled} onChange={handleChange} />
			<span className={styles.activeLabel}>{checked ? 'Ativo' : 'Inativo'}</span>
		</div>
	);
};
